<template>
  <div class="icons">
    <a v-if="discogsUrl !== null" :href="discogsUrl" target="_blank">
        <img alt="Discogs link" class="icon" width="100%" height="100%" src="/playground_assets/discogs.svg">
    </a>
    <span class="icon-heart" @click="toggleFavorite">
      <img
        :src="favorited ? '/playground_assets/heart_full.png' : '/playground_assets/heart.png'"
        alt="Favorite"
        class="icon"
      >
    </span>
        <a v-if="webShareApiSupported" @click="shareViaWebShare">
    <img alt="Share link" class="icon" width="100%" height="100%" src="/playground_assets/share.svg">
    </a>
  </div>
</template>

<script>
import { auth } from '../firebase';
import { onAuthStateChanged } from 'firebase/auth';
export default {
  name: 'TrackIcons',
  props: {
    favorited: {
      type: Boolean,
      default: false
    },
    discogsUrl: {
        type: String,
        default: null
    },
    trackTitle: {
        type: String,
        default: null
    },
    trackArtist: {
        type: String,
        default: null
    }
  },
  data() {
    return {
      user: null
    }
  },
  created() {
    onAuthStateChanged(auth, user => {
      this.user = user;
    });
  },
  methods: {
    shareViaWebShare() {
      navigator.share({
        title: 'Nuance Radio',
        text: `I discovered ${this.trackTitle} by ${this.trackArtist} on Nuance Radio.`,
        url: 'https://nuance.radio'
      })
    },
    toggleFavorite() {
      if (!this.user) {
        this.$emit('open-signup');
      } else {
        this.$emit('toggle-favorite');
      }
    }
  },
  computed: {
    webShareApiSupported() {
      return navigator.share
    }
  }
}
</script>

<style scoped>
.icons {
  justify-content: center;
  display: flex;
  flex-direction: row;
  margin-bottom: var(--dl-space-space-unit);
  width: 100%;
}
.icon {
  display: block;
  width: 17px;
  height: 17px;
  cursor: pointer;
  flex-direction: column;
  margin-right: 5px;
  margin-left: 5px;
}
.icon-heart {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 0.3vw;
}
</style>
